import { PartnerBookingOrderStatusesEnum } from 'types/generated/client';
import type { BookingOutcome } from './steps/BookingConfirmedStep';

const SETTLED_ORDER_STATUSES = [
  PartnerBookingOrderStatusesEnum.Confirmed,
  PartnerBookingOrderStatusesEnum.Failed,
  PartnerBookingOrderStatusesEnum.NeedsReview,
  PartnerBookingOrderStatusesEnum.Cancelled,
];

/** Settled means the club's system has answered and the card has moved, so polling can stop. */
export const getIsOrderSettled = (status?: string | null) =>
  !!status && SETTLED_ORDER_STATUSES.includes(status as PartnerBookingOrderStatusesEnum);

export const toBookingOutcome = (status?: string | null): BookingOutcome => {
  if (status === PartnerBookingOrderStatusesEnum.Confirmed) return 'CONFIRMED';
  if (status === PartnerBookingOrderStatusesEnum.NeedsReview) return 'NEEDS_REVIEW';
  if (
    status === PartnerBookingOrderStatusesEnum.Failed ||
    status === PartnerBookingOrderStatusesEnum.Cancelled
  ) {
    return 'FAILED';
  }
  return 'PENDING';
};
